exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chat-header{display:flex;justify-content:space-between;flex-direction:row-reverse}.chat-header .btn,.chat-header .btn-link,.chat-header .btn-link:active,.chat-header .btn:active{background:transparent}.chat-header .chat-end-btn :hover{color:#db2b2b!important}.chat-header .chat-header-minimize :hover{color:#276df0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/styles/chat-header.scss
// module id = 1164
// module chunks = 0 1